module.exports = __webpack_public_path__ + "img/720.1b04ac57.svg";